module.exports = __webpack_public_path__ + "img/doc_usergroups.98c70984.gif";